module.exports = __webpack_public_path__ + "images/token-menu.a57d1.svg";